<div class="dialog-content-wrapper">
  <mat-toolbar mat-dialog-title class="mat-accent m-0">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">Add New Activity</span>
      <button (click)="onNoClick()" aria-label="Close dialog">
        <mat-icon class="closebtn">close</mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <mat-progress-bar *ngIf="loading" mode="query" class="my-color" mode="query" value="value"
    [bufferValue]="bufferValue"></mat-progress-bar>

  <mat-form-field>
    <textarea matInput [(ngModel)]="activity" rows="6" placeholder="Enter New Activity"></textarea>
  </mat-form-field>

  <button mat-raised-button color="accent" (click)="submit()" [class.loading]="loading"
    [disabled]="!activity || activity.length == 0 || loading">SUBMIT</button>
</div>



// WEBPACK FOOTER //
// ./src/app/main/shared/dialog/add-new-activity-dialog/add-new-activity-dialog.component.html